// src/components/trades/analysis/TradeSummary.js
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const TradeSummary = ({ summary }) => {
  if (!summary) return null;

  const { winner, winner_name, point_advantage, proposing_team_name, receiving_team_name } = summary;

  const getWinnerDisplay = () => {
    if (winner === 'even') {
      return {
        icon: <Minus className="w-8 h-8 text-yellow-400" />,
        text: 'Even Trade',
        subtext: 'This trade appears fairly balanced',
        bgColor: 'bg-yellow-400/10',
        borderColor: 'border-yellow-400/30'
      };
    } else if (winner === 'proposing_team') {
      return {
        icon: <TrendingUp className="w-8 h-8 text-emerald-400" />,
        text: `${proposing_team_name} Wins`,
        subtext: `Advantage: ${point_advantage.toFixed(1)} points`,
        bgColor: 'bg-emerald-400/10',
        borderColor: 'border-emerald-400/30'
      };
    } else {
      return {
        icon: <TrendingDown className="w-8 h-8 text-red-400" />,
        text: `${receiving_team_name} Wins`,
        subtext: `They gain: ${point_advantage.toFixed(1)} points`,
        bgColor: 'bg-red-400/10',
        borderColor: 'border-red-400/30'
      };
    }
  };

  const display = getWinnerDisplay();

  return (
    <div className={`p-6 rounded-lg border ${display.borderColor} ${display.bgColor} ${dynastyTheme.classes.bg.darkCard}`}>
      <div className="flex items-center gap-4">
        {display.icon}
        <div>
          <h3 className="text-2xl font-bold text-white mb-1">{display.text}</h3>
          <p className="text-gray-400">{display.subtext}</p>
        </div>
      </div>
    </div>
  );
};

export default TradeSummary;
